import { useMutation, useQuery } from 'urql';
import { graphql } from '../../gql/index.ts';
import { MailTemplate } from '../../gql/graphql.ts';
import { MailTemplateEditor } from './MailTemplateEditor.tsx';

interface MailSettingsPageProps {
  companyId: string;
}

const MailSettingsParticipantTemplateQuery = graphql(/* GraphQL */ `
  query mailOneDayLecturerTemplate($companyId: String!) {
    company(companyId: $companyId) {
      mailSettings {
        mailTemplateReminderOneDayForLecturer {
          subject
          template
        }
      }
    }
  }
`);

const UpdateParticipantTemplateQuery = graphql(/* GraphQL */ `
  mutation updateTemplateOneDayLecturer(
    $companyId: String!
    $company: UpdateCompanyDto!
  ) {
    updateCompany(companyId: $companyId, company: $company) {
      mailSettings {
        mailTemplateReminderOneDayForLecturer {
          subject
          template
        }
      }
    }
  }
`);

export const ReminderOneDayForLecturerTemplateEditor: React.FC<
  MailSettingsPageProps
> = ({ companyId }) => {
  // TODO: Error handling
  const [{ data }, reExecuteQuery] = useQuery({
    query: MailSettingsParticipantTemplateQuery,
    variables: { companyId },
    pause: companyId === undefined || companyId === null,
  });

  const [, updateCompany] = useMutation(UpdateParticipantTemplateQuery);

  const onFormSubmit = (values: MailTemplate) => {
    updateCompany({
      companyId,
      company: {
        mailSettings: { mailTemplateReminderOneDayForLecturer: values },
      },
    }).then(() => {
      // TODO: Check for errors and indicate success/failure to UI
      reExecuteQuery();
    });
  };

  return (
    <>
      {data?.company.mailSettings.mailTemplateReminderOneDayForLecturer && (
        <MailTemplateEditor
          templateName={'Erinnerungsmail Vortag Dozent'}
          companyId={companyId}
          template={
            data.company.mailSettings.mailTemplateReminderOneDayForLecturer
          }
          onSubmit={onFormSubmit}
        />
      )}
    </>
  );
};
